import styled from 'styled-components';

export const PaymentTermsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ConditionLabel = styled.span`
  font-size: 14px;
  color: #414e55;
  padding-left: 1.2rem;
`;

export const TooltipIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  color: #874487;

  svg {
    width: 15px;
    height: 15px;
    color: #874487;
  }
`;

export const PaymentTermBadge = styled.span`
  display: inline-block;
  padding: 2px 4px;
  background: #c2c4c5;
  border-radius: 20px;
  color: #414e55;
  font-size: 14px;
  font-weight: 400;
  width: fit-content;
`;
